import type { ValuesOf } from '@tmapy/beetlejuice-utils';

import { ApprovalStateEnum } from '../openapi/types/ApprovalStateEnum';
import { StatusZadateleEnum } from '../openapi/types/StatusZadateleEnum';

export const NEW_ORDER_CLEAR = 'NEW_ORDER_CLEAR';

export const NEW_ORDER_SET_ID = 'NEW_ORDER_SET_ID';
export const NEW_ORDER_SET_AGREEMENT = 'NEW_ORDER_SET_AGREEMENT';
export const NEW_ORDER_SET_CADASTER = 'NEW_ORDER_SET_CADASTER';
export const NEW_ORDER_SET_CITIES = 'NEW_ORDER_SET_CITIES';
export const NEW_ORDER_SET_ORPS = 'NEW_ORDER_SET_ORPS';
export const NEW_ORDER_SET_PUBLISHSETS = 'NEW_ORDER_SET_PUBLISHSETS';
export const NEW_ORDER_SET_QUERY_STATE = 'NEW_ORDER_SET_QUERY_STATE';
export const NEW_ORDER_SET_REASON = 'NEW_ORDER_SET_REASON';
export const NEW_ORDER_SET_HANDLING_FEE = 'NEW_ORDER_SET_HANDLING_FEE';
export const NEW_ORDER_SET_NOTE = 'NEW_ORDER_SET_NOTE';
export const NEW_ORDER_SET_ORIGIN = 'NEW_ORDER_SET_ORIGIN';
export const NEW_ORDER_SET_REGIONS = 'NEW_ORDER_SET_REGIONS';
export const NEW_ORDER_SET_REQUIREMENTS = 'NEW_ORDER_SET_REQUIREMENTS';
export const NEW_ORDER_SET_MOMCS = 'NEW_ORDER_SET_MOMCS';

export const NEW_ORDER_ADD_ATTACHMENT = 'NEW_ORDER_ADD_ATTACHMENT';
export const NEW_ORDER_DELETE_ATTACHMENT = 'NEW_ORDER_DELETE_ATTACHMENT';
export const NEW_ORDER_INIT_ATTACHMENTS = 'NEW_ORDER_INIT_ATTACHMENTS';

export const NEW_ORDER_PUBLISHSET_ADD_FORMAT = 'NEW_ORDER_PUBLISHSET_ADD_FORMAT';
export const NEW_ORDER_PUBLISHSET_REMOVE_FORMAT = 'NEW_ORDER_PUBLISHSET_REMOVE_FORMAT';
export const NEW_ORDER_PUBLISHSET_ADD_ALL_FORMATS = 'NEW_ORDER_PUBLISHSET_ADD_ALL_FORMATS';
export const NEW_ORDER_PUBLISHSET_REMOVE_ALL_FORMATS = 'NEW_ORDER_PUBLISHSET_REMOVE_ALL_FORMATS';

export const NEW_ORDER_SET_DATA_VALIDITY = 'NEW_ORDER_SET_DATA_VALIDITY';
export const NEW_ORDER_SET_DATA_VALIDITY_STATE_DATE = 'NEW_ORDER_SET_DATA_VALIDITY_STATE_DATE';
export const NEW_ORDER_SET_DATA_VALIDITY_CHANGE_DATE_FROM =
  'NEW_ORDER_SET_DATA_VALIDITY_CHANGE_DATE_FROM';

export const NEW_ORDER_SET_SELECTION_TYPE = 'NEW_ORDER_SET_SELECTION_TYPE';
export const NEW_ORDER_SET_AREA_TYPE = 'NEW_ORDER_SET_AREA_TYPE';
export const NEW_ORDER_SET_IS_PUBLIC = 'NEW_ORDER_SET_IS_PUBLIC';

export const NEW_ORDER_SET_OVER_LIMIT_AREA = 'NEW_ORDER_SET_OVER_LIMIT_AREA';

export const NEW_ORDER_SET_PRIMARY_DB = 'NEW_ORDER_SET_PRIMARY_DB';

export const NEW_ORDER_SET_IS_REQUIREMENT_DATE = 'NEW_ORDER_SET_IS_REQUIREMENT_DATE';

export const ORDER_DETAIL_LOAD_WAITING = 'ORDER_DETAIL_LOAD_WAITING';
export const ORDER_DETAIL_LOAD_SUCCESS = 'ORDER_DETAIL_LOAD_SUCCESS';
export const ORDER_DETAIL_LOAD_FAILURE = 'ORDER_DETAIL_LOAD_FAILURE';

export const ORDER_RETRY_PROCESSING_WAITING = 'ORDER_RETRY_PROCESSING_WAITING';
export const ORDER_RETRY_PROCESSING_SUCCESS = 'ORDER_RETRY_PROCESSING_SUCCESS';
export const ORDER_RETRY_PROCESSING_FAILURE = 'ORDER_RETRY_PROCESSING_FAILURE';

export const ORDER_INTERRUPT_PROCESSING_WAITING = 'ORDER_INTERRUPT_PROCESSING_WAITING';
export const ORDER_INTERRUPT_PROCESSING_SUCCESS = 'ORDER_INTERRUPT_PROCESSING_SUCCESS';
export const ORDER_INTERRUPT_PROCESSING_FAILURE = 'ORDER_INTERRUPT_PROCESSING_FAILURE';

export const APPROVED_ORDER_WAITING = 'APPROVED_ORDER_WAITING';
export const APPROVED_ORDER_SUCCESS = 'APPROVED_ORDER_SUCCESS';
export const APPROVED_ORDER_FAILURE = 'APPROVED_ORDER_FAILURE';

// TODO - zavzit prevod na openapi - OrderStatesEnum
export const ORDER_STATE = {
  WAITING_FOR_APPROVAL: 'WAITING_FOR_APPROVAL',
  WAITING_FOR_PROCESSING: 'WAITING_FOR_PROCESSING',
  PROCESSING: 'PROCESSING',
  WAITING_FOR_INTERRUPTION: 'WAITING_FOR_INTERRUPTION',
  INTERRUPTED: 'INTERRUPTED',
  REJECTED: 'REJECTED',
  PUBLISHED: 'PUBLISHED',
  FAILED: 'FAILED',
  DMVS_COMMUNICATION_FAILED: 'DMVS_COMMUNICATION_FAILED',
  EXPIRED: 'EXPIRED',
  APPROVED: 'APPROVED',
} as const;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type ORDER_STATE = ValuesOf<typeof ORDER_STATE>;

export const NEW_ORDER_STEPS = {
  PUBLISH_SETS: 1,
  REGIONS: 2,
  REASON: 3,
  SUMMARY: 4,
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type NEW_ORDER_STEPS = ValuesOf<typeof NEW_ORDER_STEPS>;

export const ORDER_REGION_TYPES = {
  CUSTOM: 'CUSTOM',
  CADASTER: 'CADASTER',
  ORP: 'ORP',
  OBEC: 'OBEC',
  KRAJ: 'KRAJ',
  MOMC: 'MOMC',
  SHPDGN: 'SHPDGN',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type ORDER_REGION_TYPES = ValuesOf<typeof ORDER_REGION_TYPES>;

/**
 * Enum:
 * - WAITING
 * - APPROVED
 * - REJECTED
 */
export const APPROVAL_STATE = ApprovalStateEnum;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type APPROVAL_STATE = ValuesOf<typeof APPROVAL_STATE>;

export type OrderFormTypes = 'gp' | 'ipr' | 'dtm' | 'cepro' | 'bb';

export type UsableItems = (
  | 'state'
  | 'created'
  | 'published'
  | 'creator'
  | 'origin'
  | 'ordering_reason'
  | 'note'
  | 'selection_type'
  | 'dmvs_id_podani'
  | 'dmvs_source'
  | 'status_zadatele'
  | 'publishsets'
  | 'data_origin'
  | 'approvals'
  | 'attachments'
  | 'order_attachments'
  | 'areas'
  | 'subjekt'
  | 'is_public'
  | 'from_primary_db'
  | 'order_data_state_valid_at'
  | 'ipr_taxable_supply_date'
  | 'ipr_documents'
  | 'ipr_price_summary'
)[];

export const usableItemsForFormType: Partial<Record<OrderFormTypes, Partial<UsableItems>>> = {
  dtm: [
    'state',
    'created',
    'published',
    'creator',
    'ordering_reason',
    'selection_type',
    'dmvs_id_podani',
    'dmvs_source',
    'status_zadatele',
    'publishsets',
    'data_origin',
    'approvals',
    'attachments',
    'areas',
    'subjekt',
    'is_public',
    'from_primary_db',
    'order_data_state_valid_at',
  ],
  gp: [
    'state',
    'created',
    'published',
    'creator',
    'ordering_reason',
    'publishsets',
    'data_origin',
    'approvals',
    'attachments',
    'areas',
    'order_data_state_valid_at',
  ],
  ipr: [
    'state',
    'created',
    'published',
    'creator',
    'origin',
    'ordering_reason',
    'note',
    'selection_type',
    'dmvs_id_podani',
    'dmvs_source',
    'status_zadatele',
    'publishsets',
    'data_origin',
    'approvals',
    'order_attachments',
    'areas',
    'subjekt',
    'is_public',
    'from_primary_db',
    'order_data_state_valid_at',
    'ipr_taxable_supply_date',
    'ipr_documents',
    'ipr_price_summary',
  ],
  cepro: [
    'state',
    'created',
    'published',
    'creator',
    'ordering_reason',
    'publishsets',
    'data_origin',
    'approvals',
    'attachments',
    'areas',
  ],
  bb: [
    'state',
    'created',
    'published',
    'creator',
    'ordering_reason',
    'publishsets',
    'data_origin',
    'approvals',
    'attachments',
    'areas',
  ],
};

export const ORDER_DMVS_SOURCE: Record<string, string> = {
  R20B: 'DMVS (R20b)',
  R21B: 'DMVS (R21b)',
  R22B: 'DMVS (R22b)',
  R27A: 'DMVS (R27a)',
  R30B: 'DMVS (R30b)',
  DTM: 'DTM',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type ORDER_DMVS_SOURCE = ValuesOf<typeof ORDER_DMVS_SOURCE>;

export const ORDER_DMVS_SOURCE_ITEMS: Record<string, string> = {
  'DMVS (R20b)': 'R20B_STAVOVA,R20B_ZMENOVA',
  'DMVS (R21b)': 'R21B_STAVOVA,R21B_ZMENOVA',
  'DMVS (R22b)': 'R22B_VSP',
  'DMVS (R27a)': 'R27A_VEREJNA,R27A_NEVEREJNA',
  'DMVS (R30b)': 'R30B_SYNCHRONIZACNI',
  DTM: 'DTM',
};

export const STATUS_ZADATELE_FILTER = {
  null: 'null',
  ...StatusZadateleEnum,
} as const;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type STATUS_ZADATELE_FILTER = ValuesOf<typeof STATUS_ZADATELE_FILTER>;